module.exports = __webpack_public_path__ + "img/day04.76527627.png";